import { gql } from '@apollo/client';
import { GEO_DATA_FRAGMENT } from 'graphql/secure/fragments/geoData.fragments';

export const PROCESS_GEO_DATAS = gql`
  mutation ProcessGeoDatas($ids: [UUID]!) {
    processGeoDatas(ids: $ids) {
      geoDatas {
        ...geoDataValues
      }
    }
  }
  ${GEO_DATA_FRAGMENT}
`;

export const EXPORT_GEO_DATA = gql`
  mutation ExportGeoData($input: ExportGeoDataInput!) {
    exportGeoData(input: $input) {
      fileUrl
    }
  }
`;
